<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SByJ0l/tc-custom/9780300159912.jpg?1708774719423" alt="This image is the cover for the book Gallipoli"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gallipoli
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The noted historian’s decisive and devastating history of the WWI Battle of Gallipoli “sets a new standard for assessing the Allied Dardanelles campaign" (Mustafa Aksakal, <i>American Historical Review</i>).</b><br/><br/> The Gallipoli campaign of 1915–16 was an ill-fated Allied attempt to take control of the Dardanelles, secure a sea route to Russia, and create a Balkan alliance against the Central Powers. A failure in all respects, the operation ended in disaster, and the Allied forces suffered some 390,000 casualties. In this conclusive study, military historian Robin Prior assesses the many myths about Gallipoli and provides definitive answers to questions that have lingered about the operation.<br/>  <br/> Prior proceeds step by step through the campaign, dealing with naval, military, and political matters and surveying the operations of all the armies involved: British, Anzac, French, Indian, and Turkish. Relying on primary documents, including war diaries and technical military sources, Prior evaluates the strategy, the commanders, and the performance of soldiers on the ground.<br/> His conclusions are powerful and unsettling: the naval campaign was not “almost” won, and the land action was not bedeviled by “minor misfortunes.” Instead, the badly conceived Gallipoli campaign was doomed from the start. And even had it been successful, the operation would not have shortened the war by a single day. Despite their bravery, the Allied troops who fell at Gallipoli died in vain.<br/><b>A <i>Wall Street Journal</i> Best Book of 2009</b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robin Prior
      </h2>
      
      <p class="authorDescription body article">Robin Prior is visiting professorial fellow, University of Adelaide, and visiting fellow, University of New South Wales, Australian Defence Force Academy. He is the coauthor of Passchendaele: The Untold Story and The Somme, both published by Yale University Press. He lives in South Australia.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Yale University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cb0aa810